import React from 'react';
import { Tooltip, Tag } from 'antd';
import { 
    SyncOutlined, 
    CheckCircleOutlined, 
    ExclamationCircleOutlined,
    CloseCircleOutlined,
    InfoCircleOutlined
} from '@ant-design/icons';
import { hasFieldMapping, getFieldMapping } from '../../services/fieldMatchingService';

const SyncIndicator = ({ field, style = {} }) => {
    
    if (!field || field.type === 'C') {
        return null;
    }
    
    const mapping = getFieldMapping(field);
    
    if (!mapping) {
        return null; 
    }
    
    const { amoField, compatible } = mapping;
    
    if (!compatible) {
        return null; 
    }
    
    return (
        <Tooltip title={`Синхронизируется с AMO полем "${amoField.name}"`}>
            <Tag 
                icon={<SyncOutlined />} 
                color="success" 
                style={{ fontSize: '12px', ...style }}
            >
                AMO: {amoField.name}
            </Tag>
        </Tooltip>
    );
};

export default SyncIndicator; 